module.exports = __webpack_public_path__ + "static/img/autumn_jianjiePic.2a6c4c5f.png";